import React from "react";
import { industryMapping } from "../../utils/mappings";
import { formatTime } from "../../utils/formatTime";

export function ItemProduction({ item }) {
  if (!item?.produce || !Array.isArray(item?.produce) || item.produce.length === 0) return null;

  return (
    <div className="wiki-production">
      <h3 className="text-lg font-semibold mb-3 text-[var(--text-color)]">Production Details</h3>

      {item.produce.map((production, index) => {
        const { expType, tier, level, industry, growTime, energy, exp, dropAmt, dropChance, ver, feedName } = production;

        return (
          <div key={index} className="production-entry mb-4 p-3 border border-[var(--border-color)] rounded">
            {/* Basic Info */}

            <div className="item-line">
              <span className="item-title">Industry:</span> <span className="capitalize">{industry || industryMapping[expType]}</span>
              <br />
              <span className="item-title"> Tier:</span> <span>{tier || ver || "N/A"}</span>
            </div>

            {feedName && (
              <div className="item-line">
                <span className="item-title">Feed:</span> <span>{feedName}</span>
              </div>
            )}

            <div className="item-line">
              <span className="item-title">Skill:</span> <span className="capitalize">{industryMapping[expType]}</span>
            </div>

            <div className="item-line">
              <span className="item-title">Required Level:</span> <span>{level || 0}</span>
            </div>

            {/* Time and Energy */}
            <div className="item-line">
              <span className="item-title">Time To Collect:</span> <span>{growTime !== "-" ? formatTime(growTime) : "Depends on base item"}</span>
            </div>

            <div className="item-line">
              <span className="item-title">Energy Cost:</span> <span>{energy ? `⚡${energy}` : "Depends on Base Item"} </span>
            </div>

            {/* Drops */}
            <div className="item-line">
              <span className="item-title">Exp:</span> <span>{exp}</span>
            </div>

            <div className="item-line">
              <span className="item-title">Drop Amount:</span> <span>{dropAmt}</span>
            </div>

            {/* Conditional Drop Chance */}
            <div className="item-line">
              <span className="item-title">Drop Chance:</span> <span>{dropChance ? `${dropChance}%` : "N/A"}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
